import BaseApiRequest from "./BaseApiRequest";
import { STAFF_URL } from "../ApiUrls";
import { METHOD } from "../Constants";
import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class GetStaffListRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  getMethod = () => this.method;

  getUrl = () => {
    return getCurrentUserParameters(`${STAFF_URL}?t=${new Date().getTime()}`);
  };

  getBody = () => this.body;
}
